$(document).on(
  "taydu2_cuuthienhuyennu_float_right rendered",
  {},
  function (event, uniqueId) {
    var $this = $("#" + uniqueId);

    // console.log(event);
    // console.log(uniqueId);
    // console.log($this);
    $this.find(".close").on("click", function () {
      $(this).toggleClass("active");
      $this.find(".aside").toggleClass("active");
    });
  }
);
